import React from 'react';

import styles from './TabSwitcher.scss';

class TabSwitcher extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(tab) {
    this.props.clickHandler(tab);
    window.scrollTo(0, 0);
  }

  render() {
    const { tabs, activeTab } = this.props;
    return (
      <div className="TabSwitcher">
        <div className="TabSwitcher__items">
          {tabs.map(tab => (
            <div
              className={`TabSwitcher__tab${
                activeTab === tab.value ? ' is-active' : ''
              }`}
              onClick={() => this.handleClick(tab.value)}
              key={`tab-${tab.value}`}
            >
              {tab.label}
              {tab.listLength ? (
                <span className="TabSwitcher__list-count">
                  {' '}
                  ({tab.listLength})
                </span>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default TabSwitcher;
